export default "__VITE_ASSET__BVZYmPYQ__"